module.exports = __webpack_public_path__ + "img/right_arrow.0aba91d6.svg";